import { PerformanceRating } from 'nomst/Stores/Configuration/performanceRating';

export class RatingConfiguration {
    private _showPerformanceRating: boolean;

    private _allowEditPerformanceRating: boolean;

    private readonly _performanceRatingsMap: Map<string, PerformanceRating>;

    constructor(
        showPerformanceRating: boolean,
        allowEditPerformanceRating: boolean,
        performanceRatings: PerformanceRating[]) {
        this._showPerformanceRating = showPerformanceRating;
        this._allowEditPerformanceRating = allowEditPerformanceRating;
        this._performanceRatingsMap = new Map(performanceRatings.map(performanceRating => [
            performanceRating.name,
            performanceRating] as [string, PerformanceRating]));
    }

    get showPerformanceRating(): boolean {
        return this._showPerformanceRating;
    }

    get allowEditPerformanceRating(): boolean {
        return this._allowEditPerformanceRating;
    }

    get performanceRatings(): PerformanceRating[] {
        return Array.from(this._performanceRatingsMap.values());
    }

    setShowPerformanceRating(value: boolean): void {
        this._showPerformanceRating = value;
        if (!value) {
            this.setAllowEditPerformanceRating(value);
        }
    }

    setAllowEditPerformanceRating(value: boolean): void {
        this._allowEditPerformanceRating = value;
    }

    getPerformanceRating(name: string): Nullable<PerformanceRating> {
        return this._performanceRatingsMap.get(name) ?? null;
    }
}